import type { PageType } from "../schema/index.js";

const ALL_EDITOR_COMPONENTS = "*" as const;

type ComponentAllowList = typeof ALL_EDITOR_COMPONENTS | readonly string[];

export const PAGE_TYPE_COMPONENTS: Record<PageType, ComponentAllowList> = {
  lead_capture: [
    "Hero",
    "WebinarRegistration",
    "VideoBackground",
    "Heading",
    "Text",
    "RichText",
    "Image",
    "TextBlock",
    "FeatureCard",
    "Blockquote",
    "CodeBlock",
    "IconText",
    "Alert",
    "Testimonials",
    "StatsCounter",
    "LogoCloud",
    "ClientLogos",
    "SocialProof",
    "SocialProofPopup",
    "Awards",
    "CaseStudy",
    "SocialFeed",
    "Counter",
    "Button",
    "ContactForm",
    "LeadForm",
    "MultiStepForm",
    "BookingWidget",
    "CtaBanner",
    "Newsletter",
    "Survey",
    "AppointmentForm",
    "WaitlistForm",
    "CallBooking",
    "FloatingCta",
    "ScrollTriggeredCta",
    "FaqAccordion",
    "FeatureGrid",
    "Timeline",
    "Tabs",
    "Accordion",
    "DataTable",
    "ComparisonTable",
    "ProgressBar",
    "VideoEmbed",
    "Gallery",
    "BeforeAfter",
    "Carousel",
    "ImageEnhanced",
    "ImageHotspot",
    "EmbedWidget",
    "VideoPlayer",
    "MapEmbed",
    "CountdownTimer",
  ],
  webinar: [
    "Hero",
    "WebinarRegistration",
    "VideoBackground",
    "Heading",
    "Text",
    "RichText",
    "Image",
    "TextBlock",
    "FeatureCard",
    "Blockquote",
    "CodeBlock",
    "IconText",
    "Alert",
    "Testimonials",
    "StatsCounter",
    "LogoCloud",
    "ClientLogos",
    "SocialProof",
    "SocialProofPopup",
    "Awards",
    "CaseStudy",
    "SocialFeed",
    "Counter",
    "Button",
    "ContactForm",
    "LeadForm",
    "MultiStepForm",
    "BookingWidget",
    "CtaBanner",
    "Newsletter",
    "Survey",
    "AppointmentForm",
    "WaitlistForm",
    "CallBooking",
    "FloatingCta",
    "ScrollTriggeredCta",
    "FaqAccordion",
    "FeatureGrid",
    "Timeline",
    "Tabs",
    "Accordion",
    "DataTable",
    "ComparisonTable",
    "ProgressBar",
    "VideoEmbed",
    "Gallery",
    "BeforeAfter",
    "Carousel",
    "ImageEnhanced",
    "ImageHotspot",
    "EmbedWidget",
    "VideoPlayer",
    "MapEmbed",
    "CountdownTimer",
  ],
  sales: [
    "Container",
    "SectionBlock",
    "Columns",
    "Grid",
    "Spacer",
    "Divider",
    "StickySection",
    "Hero",
    "WebinarRegistration",
    "VideoBackground",
    "Heading",
    "Text",
    "RichText",
    "Image",
    "TextBlock",
    "FeatureCard",
    "Blockquote",
    "CodeBlock",
    "IconText",
    "Alert",
    "Testimonials",
    "StatsCounter",
    "LogoCloud",
    "ClientLogos",
    "SocialProof",
    "SocialProofPopup",
    "Awards",
    "CaseStudy",
    "SocialFeed",
    "Counter",
    "Button",
    "ContactForm",
    "LeadForm",
    "MultiStepForm",
    "BookingWidget",
    "CtaBanner",
    "Newsletter",
    "Survey",
    "AppointmentForm",
    "WaitlistForm",
    "CallBooking",
    "FloatingCta",
    "ScrollTriggeredCta",
    "ChatWidget",
    "NavigationBar",
    "FooterBlock",
    "Breadcrumb",
    "BackToTop",
    "SocialIcons",
    "LanguageSwitcher",
    "NotificationBar",
    "FaqAccordion",
    "FeatureGrid",
    "Timeline",
    "Tabs",
    "Accordion",
    "DataTable",
    "ComparisonTable",
    "ProgressBar",
    "ClassSchedule",
    "StaffSelector",
    "PricingTable",
    "RoiCalculator",
    "OfferCard",
    "ServiceMenu",
    "Coupon",
    "GiftCard",
    "PaymentButton",
    "MembershipPlans",
    "VideoEmbed",
    "Gallery",
    "BeforeAfter",
    "Carousel",
    "ImageEnhanced",
    "ImageHotspot",
    "EmbedWidget",
    "VideoPlayer",
    "MapEmbed",
    "CountdownTimer",
  ],
  booking: [
    "Hero",
    "VideoBackground",
    "Heading",
    "Text",
    "RichText",
    "Image",
    "TextBlock",
    "FeatureCard",
    "IconText",
    "Testimonials",
    "StatsCounter",
    "LogoCloud",
    "SocialProof",
    "Button",
    "BookingWidget",
    "CtaBanner",
    "AppointmentForm",
    "CallBooking",
    "FaqAccordion",
    "FeatureGrid",
    "Tabs",
    "ComparisonTable",
    "VideoEmbed",
    "Gallery",
    "BeforeAfter",
    "Carousel",
    "ImageEnhanced",
    "MapEmbed",
    "CountdownTimer",
  ],
  thank_you: [
    "Hero",
    "Heading",
    "Text",
    "RichText",
    "Image",
    "TextBlock",
    "FeatureCard",
    "Blockquote",
    "CodeBlock",
    "IconText",
    "Alert",
    "Testimonials",
    "StatsCounter",
    "LogoCloud",
    "ClientLogos",
    "SocialProof",
    "SocialProofPopup",
    "Awards",
    "CaseStudy",
    "SocialFeed",
    "Counter",
    "FaqAccordion",
    "FeatureGrid",
    "Timeline",
    "Tabs",
    "Accordion",
    "DataTable",
    "ProgressBar",
    "VideoEmbed",
    "Gallery",
    "BeforeAfter",
    "Carousel",
    "ImageEnhanced",
    "ImageHotspot",
    "VideoPlayer",
    "MapEmbed",
  ],
  link_in_bio: [
    "Hero",
    "Heading",
    "Text",
    "RichText",
    "Image",
    "Button",
    "Testimonials",
    "StatsCounter",
    "LogoCloud",
    "SocialProof",
    "SocialIcons",
    "ImageEnhanced",
    "Gallery",
  ],
  custom: ALL_EDITOR_COMPONENTS,
  site_page: ALL_EDITOR_COMPONENTS,
  blog_post: [
    "Heading",
    "Text",
    "RichText",
    "Image",
    "TextBlock",
    "FeatureCard",
    "Blockquote",
    "CodeBlock",
    "IconText",
    "Alert",
    "VideoEmbed",
    "Gallery",
    "BeforeAfter",
    "Carousel",
    "ImageEnhanced",
    "ImageHotspot",
    "EmbedWidget",
    "VideoPlayer",
    "MapEmbed",
  ],
  funnel_step: ALL_EDITOR_COMPONENTS,
  course_lesson: ALL_EDITOR_COMPONENTS,
  course_exercise: ALL_EDITOR_COMPONENTS,
  certificate: ALL_EDITOR_COMPONENTS,
};

export function getAllowedComponentsForPageType(pageType: PageType): ComponentAllowList {
  return PAGE_TYPE_COMPONENTS[pageType];
}

export function getComponentsForPageType<T>(
  components: Record<string, T>,
  pageType: PageType,
): Record<string, T> {
  const allowed = getAllowedComponentsForPageType(pageType);
  if (allowed === ALL_EDITOR_COMPONENTS) {
    return components;
  }

  const filtered = Object.fromEntries(
    Object.entries(components).filter(([name]) => allowed.includes(name)),
  );

  return filtered;
}
